module.exports = __webpack_public_path__ + "img/my-female.7facedaa.png";